import { render, staticRenderFns } from "./TimerWidget.vue?vue&type=template&id=844959a8&scoped=true&"
import script from "./TimerWidget.vue?vue&type=script&lang=js&"
export * from "./TimerWidget.vue?vue&type=script&lang=js&"
import style0 from "./TimerWidget.vue?vue&type=style&index=0&id=844959a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844959a8",
  null
  
)

export default component.exports